/**
 * Copyright (c) 2016-2017 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */
import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ClrIconModule } from "../../icon/icon.module";
import { ClrDropdownModule } from "../../popover/dropdown/dropdown.module";
import { ALERT_DIRECTIVES } from "./index";
var ClrAlertModule = (function () {
    function ClrAlertModule() {
    }
    return ClrAlertModule;
}());
export { ClrAlertModule };
ClrAlertModule.decorators = [
    { type: NgModule, args: [{
                imports: [
                    CommonModule,
                    ClrIconModule,
                    ClrDropdownModule
                ],
                declarations: [
                    ALERT_DIRECTIVES
                ],
                exports: [
                    ALERT_DIRECTIVES
                ]
            },] },
];
/** @nocollapse */
ClrAlertModule.ctorParameters = function () { return []; };
//# sourceMappingURL=alert.module.js.map


//////////////////
// WEBPACK FOOTER
// ./~/clarity-angular/emphasis/alert/alert.module.js
// module id = 54
// module chunks = 4